import { ReactNode } from 'react';
import { autoUpdate, flip, offset, useFloating } from '@floating-ui/react-dom';

import { cx } from '@libs/classnames';
import { Card } from '@ui/components/Card';

import styles from './Tooltip.module.css';

type Props = {
  className?: string;
  tooltipClassName?: string;
  text: ReactNode;
  children: ReactNode;
};
export function Tooltip({ className, tooltipClassName, children, text }: Props) {
  const floating = useFloating({
    placement: 'top',
    whileElementsMounted: autoUpdate,
    middleware: [flip(), offset()],
  });

  return (
    <span className={cx(styles.tooltipContainer, className)} ref={floating.refs.setReference}>
      {children}

      <Card
        className={cx(styles.tooltip, tooltipClassName)}
        ref={floating.refs.setFloating}
        style={floating.floatingStyles}
      >
        {text}
      </Card>
    </span>
  );
}
